import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LayoutFullScreenOverlay from "@/ui/layouts/LayoutFullScreenOverlay";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";
import { ViewFileUpload } from "@/ui/compositionRootUI";

export const FileUploadOverlay: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { databaseId, projectId } = useParams() as {
        databaseId: string;
        projectId: string;
    };

    const handleOverlayClick = () => {
        const basePath = location.pathname.split("files/upload")[0];
        if (typeof basePath === "string") {
            navigate(basePath);
        }
    };

    return (
        <LayoutFullScreenOverlay
            backgroundColor={"var(--proda-black)"}
            opacity={0.8}
            onClick={handleOverlayClick}
        >
            <LayoutFillParentCentered>
                <ViewFileUpload
                    projectId={parseInt(projectId)}
                    databaseId={parseInt(databaseId)}
                    handleCancelClicked={handleOverlayClick}
                    LayoutBoxCenteredProps={{
                        onClick: e => e.stopPropagation(),
                    }}
                    sx={{ width: "100%" }}
                />
            </LayoutFillParentCentered>
        </LayoutFullScreenOverlay>
    );
};
